import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { useOnScreen } from '@beef/utils';
import { isFeatureToggleEnabled } from "../../../constants/featureToggle";
import { HORIZONTAL_CLICK_OPTIONS, HORIZONTAL_START_OPTIONS, VERTICAL_CLICK_OPTIONS, VERTICAL_START_OPTIONS } from "./constants";
import style from "./styles.pcss";
var cn = classNames.bind(style);

/* toDo: сделать рефактор компонента, выкинуть лишние варианты и стили */

export var Tab = /*#__PURE__*/memo(function (_ref) {
  var _cn;
  var icon = _ref.icon,
    id = _ref.id,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    isTabFocus = _ref.isTabFocus,
    isUpperCase = _ref.isUpperCase,
    link = _ref.link,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {
      return false;
    } : _ref$onBlur,
    onClick = _ref.onClick,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? function () {
      return false;
    } : _ref$onFocus,
    customDescription = _ref.customDescription,
    selected = _ref.selected,
    description = _ref.description,
    title = _ref.title,
    variant = _ref.variant,
    tabBeforeSelected = _ref.tabBeforeSelected,
    noWrap = _ref.noWrap,
    isVertical = _ref.isVertical,
    isScrollable = _ref.isScrollable,
    isInView = _ref.isInView,
    isTabsHaveAppeared = _ref.isTabsHaveAppeared,
    onView = _ref.onView;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    anchorAttributes = _useState2[0],
    setAnchorAttributes = _useState2[1];
  var Tag = useMemo(function () {
    return link ? 'a' : 'button';
  }, [link]);
  var ref = useRef(null);
  var handleClick = useCallback(function () {
    onClick(id);
    if (isScrollable) {
      var _ref$current;
      ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollIntoView(isVertical ? VERTICAL_CLICK_OPTIONS : HORIZONTAL_CLICK_OPTIONS);
    }
  }, [onClick, id, isScrollable, isVertical]);
  var handleBlur = useCallback(function () {
    onBlur(id);
  }, [id, onBlur]);
  var handleFocus = useCallback(function () {
    onFocus(id);
  }, [id, onFocus]);
  var isTabBeforeSelected = useMemo(function () {
    return tabBeforeSelected || tabBeforeSelected === 0;
  }, [tabBeforeSelected]);
  useEffect(function () {
    if (link) {
      setAnchorAttributes({
        href: link
      });
    }
  }, [link]);
  useEffect(function () {
    if (isTabsHaveAppeared !== null && isTabsHaveAppeared !== void 0 && isTabsHaveAppeared.current && isInView && isScrollable && selected) {
      var _ref$current2;
      ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.scrollIntoView(isVertical ? VERTICAL_START_OPTIONS : HORIZONTAL_START_OPTIONS);
      isTabsHaveAppeared.current = false;
    }
  }, [isInView, isTabsHaveAppeared]);
  var isItemInView = useOnScreen(ref);
  useEffect(function () {
    if (isItemInView) {
      onView === null || onView === void 0 ? void 0 : onView(id);
    }
  }, [isItemInView]);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cn('tab', (_cn = {}, _defineProperty(_cn, "tab--".concat(variant), Boolean(variant)), _defineProperty(_cn, "tab--".concat(variant, "--vertical"), Boolean(variant) && isVertical), _defineProperty(_cn, 'tab--first', isFirst), _defineProperty(_cn, 'tab--last', isLast), _defineProperty(_cn, 'tab--last-extended', isLast && variant === 'extended-main'), _defineProperty(_cn, 'tab--last-plain', isLast && variant === 'plain'), _defineProperty(_cn, 'tab--last-secondary', isLast && variant === 'secondary'), _defineProperty(_cn, 'tab--last-tertiary', isLast && variant === 'tertiary'), _defineProperty(_cn, 'tab--first-extended', isFirst && variant === 'extended-main'), _defineProperty(_cn, 'tab--first-secondary', isFirst && variant === 'secondary'), _defineProperty(_cn, 'tab--first-tertiary', isFirst && variant === 'tertiary'), _defineProperty(_cn, 'tab--first-plain', isFirst && variant === 'plain'), _defineProperty(_cn, 'tab--selected', selected), _defineProperty(_cn, 'tab--selected-main', selected && variant === 'main'), _defineProperty(_cn, 'tab--selected-contour', selected && variant === 'contour'), _defineProperty(_cn, 'tab--selected-secondary', selected && variant === 'secondary'), _defineProperty(_cn, 'tab--selected-plain', selected && variant === 'plain'), _defineProperty(_cn, 'tab--selected-tertiary', selected && variant === 'tertiary'), _defineProperty(_cn, 'tab--selected-tertiary-vertical', selected && variant === 'tertiary'), _defineProperty(_cn, 'tab--first-contour', selected && variant === 'contour'), _defineProperty(_cn, 'tab--last-contour', selected && variant === 'contour'), _defineProperty(_cn, 'tab--before-selected', isTabBeforeSelected), _defineProperty(_cn, 'tab--focus', isTabFocus), _defineProperty(_cn, 'tab--focus-secondary', isTabFocus && variant === 'secondary'), _defineProperty(_cn, 'tab--focus-plain', isTabFocus && variant === 'plain'), _defineProperty(_cn, 'tab--focus-tertiary', isTabFocus && variant === 'tertiary'), _defineProperty(_cn, 'tab--no-wrap', noWrap), _defineProperty(_cn, 'tab--feature-toggle', isFeatureToggleEnabled), _defineProperty(_cn, "tab--feature-toggle-".concat(variant), isFeatureToggleEnabled && variant), _cn)),
    onBlur: handleBlur,
    onClick: handleClick,
    onFocus: handleFocus
  }, anchorAttributes), /*#__PURE__*/React.createElement("div", {
    className: cn('tab__heading', {
      'tab__heading--selected': selected && variant !== 'extended-main' && variant !== 'secondary' && variant !== 'tertiary',
      'tab__heading--selected-custom': selected && variant === 'custom'
    }),
    ref: ref
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: cn('tab__icon')
  }, icon), /*#__PURE__*/React.createElement("span", {
    className: cn('tab__title', "tab__title--".concat(variant), {
      'tab__title--uppercase': isUpperCase
    })
  }, title)), (description || customDescription) && /*#__PURE__*/React.createElement("div", {
    className: cn('tab__description', "tab__description--".concat(variant), _defineProperty({
      'tab__description--with-icon': Boolean(icon),
      'tab__description--uppercase': isUpperCase,
      'tab__description--selected': selected
    }, "tab__description--".concat(variant, "-selected"), selected))
  }, description || customDescription));
});